module.exports = __webpack_public_path__ + "static/baileywithmike-cook-5e2c372d58821d3ef289e5eec55bdbe5.jpg";